// extracted by mini-css-extract-plugin
module.exports = {"content":"iR","promoWrapper":"jR","selected":"kR"};